import { createReducer, on } from '@ngrx/store';
import { CalendarState } from '../../models/calendar-state';
import { RoleState } from '../../models/role-state';
import * as calendarsActions from './calendars.actions';

export const calendarsKey = 'calendars';
export const rolesKey = 'roles';

export const calendarInitialState: CalendarState = {
  calendars: [],
  editCalendar: null,
  isLoaded: false,
  isLoading: false,
  loadMessages: false
};

export const roleInitialState: RoleState = {
  roles: [],
  isLoaded: false,
  isLoading: false,
  loadMessages: false
};

export const calendarReducer = createReducer(
  calendarInitialState,
  on(calendarsActions.calendarList, (state) => ({
    ...state,
    isLoading: true,
    isLoaded: false,
    loadMessages: false
  })),
  on(calendarsActions.calendarListSuccess, (state, response) => ({
    ...state,
    calendars: response.calendars,
    isLoading: false,
    loadMessages: false,
    isLoaded: true
  }))
);

export const roleReducer = createReducer(
  roleInitialState,
  on(calendarsActions.rolesList, (state) => ({
    ...state,
    isLoading: true,
    isLoaded: false,
    loadMessages: false
  })),
  on(calendarsActions.rolesListSuccess, (state, response) => ({
    ...state,
    roles: response.roles,
    isLoading: true,
    isLoaded: false,
    loadMessages: false
  }))
);
